/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbEcoleGridDto } from './FcbEcoleGridDto';
import {
    FcbEcoleGridDtoFromJSON,
    FcbEcoleGridDtoFromJSONTyped,
    FcbEcoleGridDtoToJSON,
} from './FcbEcoleGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbEcoleGridDtoPaginatedResults
 */
export interface FcbEcoleGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbEcoleGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbEcoleGridDto>}
     * @memberof FcbEcoleGridDtoPaginatedResults
     */
    results?: Array<FcbEcoleGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbEcoleGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbEcoleGridDtoPaginatedResults interface.
 */
export function instanceOfFcbEcoleGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEcoleGridDtoPaginatedResultsFromJSON(json: any): FcbEcoleGridDtoPaginatedResults {
    return FcbEcoleGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbEcoleGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEcoleGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbEcoleGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbEcoleGridDtoPaginatedResultsToJSON(value?: FcbEcoleGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbEcoleGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

